"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.provincesByCountry = void 0;
var provinces_1 = require("../provinces");
exports.provincesByCountry = new Map([
    ['CA', provinces_1.canadianProvinces],
    ['US', provinces_1.usProvinces],
]);
